const map = {
    'IOT远程控制模块': {
        position: [-20, 5, 5],
        metalness: 0.3,
    },
    '一体化智能室外机箱及配件系统': {
        metalness: 0.7,
        rotation: [0, -Math.PI / 10, 0],
        position: [-20, 5, 15],
        scale: 40,
    },
    '多功能环境监测微型站': {
        metalness: 0.7,
        scale: 65,
    },
    '负氧离子监测站': {
        metalness: 0.7,
        rotation: [Math.PI / 20, -Math.PI / 9, 0],
        scale: 60,
    },
    '积雪监测站': {
        metalness: 0.7,
        scale: 60,
    },
    '空气质量监测微型站': {
        metalness: 0.7,
        scale: 70,
    },
    '水质监测微型站': {
        metalness: 0.7,
        rotation: [0, -Math.PI / 12, 0],
        scale: 60,
    },
    '林火因子监测站': {
        metalness: 0.7,
        scale: 60,
    },
    '林下地表火监测': {
        metalness: 0.7,
        scale: 60,
    },
    '无线接入基站AP': {
        metalness: 0.7,
        scale: 60,
    },
    '无线接入网关': {
        metalness: 0.7,
        scale: 60,
    },
    '多模异构物联网基站': {
        metalness: 0.7,
        scale: 60,
    },
    '大容量多模物联基站': {
        scale: 45,
    },
    '水文监测微型站': {
        scale: 45,
        rotation: [Math.PI / 8, 0, 0],
    },
    '水质监测站': {
        y: -10
    },
    '边缘AI主机': {
        scale: 45,
        y: -12
    },
    '多模异构边缘核心网': {
        metalness: 0.5,
        rotation: [0, -Math.PI / 12, 0],
        scale: 20,
        y: -11
    },
    '资产管理网关': {
        metalness: 0.7,
        scale: 70,
        y: -7
    },
    '多模集采智算主机': {
        metalness: 0.7,
        scale: 60,
    },
    '一体化专网基站': {
        metalness: 0.3
    },
}

export default map